<template>
    <router-link :to="link">
        <slot></slot>
    </router-link>
</template>

<script>
    export default {
        name: "item-link",
        props: {
            itemType: {
                type: String,
                required: true,
            },
            itemId: {
                type: [String, Number],
                required: true,
            }
        },
        computed: {
            link() {
                if(['beattapes', 'collection'].includes(this.itemType)) return `/beat-tapes/${this.itemId}`

                const params = {};
                let name;

                if (this.itemType === 'service_quote') {
                    params.service = this.itemId;
                    name = 'service';
                } else {
                    params[this.itemType] = this.itemId;
                    name = this.itemType;
                }

                return {
                    name,
                    params
                };
            },
        }
    }
</script>

<style scoped>

</style>
